module.exports = __webpack_public_path__ + "static/img/pro4.e84ce1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro4.png
// module id = Pgyn
// module chunks = 0